// @flow
import { getCreator, postCreator } from '../../../http';
import environment from '../../../environment';

import type { Address, Country, Courier } from '../../../entities';

export type MissingSumItemApiReq = {
  amount: number;
  price: string;
  onlineStoreId?: string;
};

export type MissingSumApiReq = {
  items: MissingSumItemApiReq[];
};

export type ForecastItem = {
  amount: number;
  categoryId: number;
  originalPackaging: boolean;
  price: string;
  url: string;
  weight: string;
  shipping: string;
};

export type ForecastPricesApiReq = {
  deliveryCountry: Country;
  couponCode?: string;
  purchaseCountry: Country;
  items?: ForecastItem[];
  bagId?: string;
};

export type Tier = 'EXPRESS' | 'PRIORITY' | 'STANDARD';

export type DeliveryTier = {
  name: Tier;
  days: number;
};

export type ForecastTier = {
  itemTotal: string;
  taxes: string;
  shipping: string;
  subtotal: string;
  importationFee: string;
  customsDuties: string;
  qempo: string;
  lastMileShipping: string;
  warranty: string;
  couponDiscount: string;
  total: string;
  tier: DeliveryTier;
  travelers: number;
};

export type ForecastCourier = {
  courier: Courier;
  importationFee: string;
  customsDuties: string;
  qempo: string;
  lastMileShipping: string;
  warranty: string;
  couponDiscount: string;
  total: string;
  days: number;
};

export type Forecast = {
  DIY: ForecastCourier[];
  CLASSIC: ForecastTier[];
};

export type ForecastType = 'DIY' | 'CLASSIC';


export const endpoints = Object.freeze({
  POST_MISSING_SUM_CART: `${environment.apiUrl}/shipping/missing-sum/cart`,
  POST_MISSING_SUM_ITEMS: `${environment.apiUrl}/shipping/missing-sum/items`,
  GET_RELATED_PRODUCTS: `${environment.apiUrl}/products/related`,
  FORECAST_PRICE_CLASSIC: `${environment.apiUrl}/purchase/calculator/classic`,
  FORECAST_PRICE_CART_CLASSIC: `${environment.apiUrl}/purchase/calculator/classic/cart`,
  FORECAST_PRICE_BAG_CLASSIC: `${environment.apiUrl}/purchase/calculator/classic/bag/:bagId`,
  FORECAST_PRICE_DIY: `${environment.apiUrl}/purchase/calculator/diy`,
  FORECAST_PRICE_CART_DIY: `${environment.apiUrl}/purchase/calculator/diy/cart`,
  FORECAST_PRICE_BAG_DIY: `${environment.apiUrl}/purchase/calculator/diy/bag/:bagId`,
});

export const postMissingSumCartApi = postCreator(fetch, endpoints.POST_MISSING_SUM_CART);
export const postMissingSumItemsApi = postCreator(fetch, endpoints.POST_MISSING_SUM_ITEMS);
export const getRelatedProductsApi = getCreator(fetch, endpoints.GET_RELATED_PRODUCTS);
export const postForecastClassicPriceApi = postCreator(fetch, endpoints.FORECAST_PRICE_CLASSIC);
export const postForecastClassicPriceCartApi = postCreator(fetch, endpoints.FORECAST_PRICE_CART_CLASSIC);
export const postForecastClassicPriceBagApi = postCreator(fetch, endpoints.FORECAST_PRICE_BAG_CLASSIC);
export const postForecastDiyPriceApi = postCreator(fetch, endpoints.FORECAST_PRICE_DIY);
export const postForecastDiyPriceCartApi = postCreator(fetch, endpoints.FORECAST_PRICE_CART_DIY);
export const postForecastDiyPriceBagApi = postCreator(fetch, endpoints.FORECAST_PRICE_BAG_DIY);



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/api.js